import React from 'react';
import { supabase } from '../utils/supabaseClient';
import { uploadFile } from '../utils/storageService';

export default function RoundOverlays({
  videoRoundState, setVideoRoundState,
  videoRoundContainerKey, setVideoRoundContainerKey,
  videoRoundBlob, setVideoRoundBlob,
  videoRoundUrl, setVideoRoundUrl,
  videoRoundPosition, setVideoRoundPosition,
  videoRoundRecorderRef, videoRoundDragRef, videoRoundDidDragRef,
  videoRoundVideoRef, videoRoundPreviewRef,
  videoRoundProgress,
  videoRoundPlaying,
  videoRoundOverlayHovered, setVideoRoundOverlayHovered,
  setInsertedRoundVideos,
  audioRoundState, setAudioRoundState,
  audioRoundContainerKey, setAudioRoundContainerKey,
  audioRoundBlob, setAudioRoundBlob,
  audioRoundUrl, setAudioRoundUrl,
  audioRoundPosition, setAudioRoundPosition,
  audioRoundRecorderRef, audioRoundDragRef, audioRoundDidDragRef,
  audioRoundAudioRef,
  audioRoundProgress,
  audioRoundPlaying,
  audioRoundOverlayHovered, setAudioRoundOverlayHovered,
  setInsertedRoundAudios,
  textRoundState, setTextRoundState,
  textRoundDraft, setTextRoundDraft,
  textRoundPosition,
  textRoundContainerKey, setTextRoundContainerKey,
  textRoundDragRef,
  setInsertedRoundTexts,
  commentUploading, setCommentUploading,
  setContainerComments,
  setExpandedCommentKey,
  homeworkContentRef,
  lessonId,
}) {
  return (
    <>
      {/* Recording state UI moved inline next to the Add-comment pill
          (see LessonWorkspace.js → recording dock). Only the preview state
          remains here as a floating draggable circle for review. */}
      {videoRoundState === 'preview' && videoRoundUrl && videoRoundContainerKey && (
        <div style={{ position: 'fixed', left: videoRoundPosition.x, top: videoRoundPosition.y, zIndex: 10001, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ position: 'relative', width: 212, height: 212 }}>
            {/* Кольцо прогресса вокруг круга */}
            <svg width={212} height={212} style={{ position: 'absolute', left: 0, top: 0, transform: 'rotate(-90deg)' }}>
              <circle cx={106} cy={106} r={100} fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth={6} />
              <circle
                cx={106} cy={106} r={100}
                fill="none"
                stroke="#ee5a24"
                strokeWidth={6}
                strokeLinecap="round"
                strokeDasharray={2 * Math.PI * 100}
                strokeDashoffset={2 * Math.PI * 100 * (1 - (videoRoundProgress.duration > 0 ? videoRoundProgress.currentTime / videoRoundProgress.duration : 0))}
              />
            </svg>
            <div
              style={{
                position: 'absolute',
                left: 6,
                top: 6,
                width: 200,
                height: 200,
                borderRadius: '50%',
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
                background: '#000',
                cursor: 'grab',
              }}
              onMouseDown={(e) => {
                if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
                e.preventDefault();
                videoRoundDidDragRef.current = false;
                videoRoundDragRef.current = { isDragging: true, startX: e.clientX, startY: e.clientY, startLeft: videoRoundPosition.x, startTop: videoRoundPosition.y };
              }}
              onTouchStart={(e) => {
                if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
                const t = e.touches[0];
                videoRoundDidDragRef.current = false;
                videoRoundDragRef.current = { isDragging: true, startX: t.clientX, startY: t.clientY, startLeft: videoRoundPosition.x, startTop: videoRoundPosition.y };
              }}
            >
              <video ref={videoRoundPreviewRef} src={videoRoundUrl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div
                data-play-toggle
                role="button"
                tabIndex={0}
                onClick={(e) => { e.stopPropagation(); if (videoRoundDidDragRef.current) return; const v = videoRoundPreviewRef.current; if (!v) return; if (v.paused) v.play(); else v.pause(); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); const v = videoRoundPreviewRef.current; if (v) { if (v.paused) v.play(); else v.pause(); } } }}
                onMouseEnter={() => setVideoRoundOverlayHovered(true)}
                onMouseLeave={() => setVideoRoundOverlayHovered(false)}
                style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: !videoRoundPlaying ? 'rgba(0,0,0,0.3)' : (videoRoundOverlayHovered ? 'rgba(0,0,0,0.2)' : 'transparent') }}
              >
                {!videoRoundPlaying && (
                  <svg width="56" height="56" viewBox="0 0 24 24" fill="rgba(255,255,255,0.95)" style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}>
                    <path d="M8 5v14l11-7z" />
                  </svg>
                )}
                {videoRoundPlaying && videoRoundOverlayHovered && (
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)" style={{ opacity: 0.9 }}>
                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                  </svg>
                )}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button type="button" onClick={async () => {
              if (!videoRoundBlob || !videoRoundContainerKey) return;
              setCommentUploading(true);
              try {
                const { data: { user } } = await supabase.auth.getUser();
                const userId = user?.id || 'anonymous';
                const mime = videoRoundBlob.type;
                const ext = mime.includes('webm') ? 'webm' : 'mp4';
                const path = `users/${userId}/lessons/${lessonId || 'draft'}/comments/${videoRoundContainerKey}/${Date.now()}-video.${ext}`;
                const file = new File([videoRoundBlob], `video.${ext}`, { type: videoRoundBlob.type });
                const url = await uploadFile(file, path);
                setContainerComments(prev => ({ ...prev, [videoRoundContainerKey]: [...(prev[videoRoundContainerKey] || []), { type: 'video', body: url, createdAt: new Date().toISOString() }] }));
                setExpandedCommentKey(null);
                // Stable position: stack each new video for this container
                // vertically starting from a predictable left/top offset
                // instead of inheriting the floating preview's viewport
                // coords (which depend on scroll → "appears in different
                // places" complaint).
                setInsertedRoundVideos(prev => {
                  const existing = prev.filter(v => v.containerKey === videoRoundContainerKey).length;
                  const pos = { x: 200, y: 24 + existing * 150 };
                  return [...prev, { id: `rv-${Date.now()}-${Math.random().toString(36).slice(2)}`, containerKey: videoRoundContainerKey, videoUrl: url, position: pos, currentTime: 0, duration: 1, playing: false, overlayHovered: false }];
                });
              } catch (err) { console.error(err); }
              finally { setCommentUploading(false); }
              if (videoRoundUrl) URL.revokeObjectURL(videoRoundUrl);
              setVideoRoundState(null); setVideoRoundContainerKey(null); setVideoRoundBlob(null); setVideoRoundUrl(null);
            }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
              style={{
                padding: '8px 20px',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: '#fff', border: 'none', borderRadius: 999,
                cursor: 'pointer', fontSize: 13, fontWeight: 600,
                boxShadow: '0 4px 12px rgba(99, 102, 241, 0.32)',
                transition: 'transform 140ms ease, filter 140ms ease',
              }}>Insert</button>
            <button
              type="button"
              onClick={() => { if (videoRoundUrl) URL.revokeObjectURL(videoRoundUrl); setVideoRoundState(null); setVideoRoundContainerKey(null); setVideoRoundBlob(null); setVideoRoundUrl(null); }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.transform = ''; }}
              style={{
                padding: '8px 18px',
                background: '#f1f5f9',
                color: '#334155',
                border: '1px solid #cbd5e1',
                borderRadius: 999,
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: 600,
                boxShadow: '0 2px 6px rgba(15, 23, 42, 0.08)',
                transition: 'background 140ms ease, transform 140ms ease',
              }}>Cancel</button>
          </div>
        </div>
      )}

      {/* Audio recording UI is now rendered inline by LessonWorkspace as
          a "recording dock" above the Add-comment pill. The old floating
          200×200 viewport circle has been retired. */}
      {/* Круглое аудио: превью — перетаскиваемый круг с анимацией, play/pause, Insert/Cancel */}
      {audioRoundState === 'preview' && audioRoundUrl && audioRoundContainerKey && (
        <div style={{ position: 'fixed', left: audioRoundPosition.x, top: audioRoundPosition.y, zIndex: 10001, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ position: 'relative', width: 212, height: 212 }}>
            <svg width={212} height={212} style={{ position: 'absolute', left: 0, top: 0, transform: 'rotate(-90deg)' }}>
              <circle cx={106} cy={106} r={100} fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth={6} />
              <circle cx={106} cy={106} r={100} fill="none" stroke="#43a047" strokeWidth={6} strokeLinecap="round" strokeDasharray={2 * Math.PI * 100} strokeDashoffset={2 * Math.PI * 100 * (1 - (audioRoundProgress.duration > 0 ? audioRoundProgress.currentTime / audioRoundProgress.duration : 0))} />
            </svg>
            <div
              style={{ position: 'absolute', left: 6, top: 6, width: 200, height: 200, borderRadius: '50%', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.35)', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', cursor: 'grab' }}
              onMouseDown={(e) => { if (e.target.closest('button')) return; e.preventDefault(); audioRoundDidDragRef.current = false; audioRoundDragRef.current = { isDragging: true, startX: e.clientX, startY: e.clientY, startLeft: audioRoundPosition.x, startTop: audioRoundPosition.y }; }}
              onTouchStart={(e) => { if (e.target.closest('button')) return; const t = e.touches[0]; audioRoundDidDragRef.current = false; audioRoundDragRef.current = { isDragging: true, startX: t.clientX, startY: t.clientY, startLeft: audioRoundPosition.x, startTop: audioRoundPosition.y }; }}
            >
              <audio ref={audioRoundAudioRef} src={audioRoundUrl} style={{ display: 'none' }} />
              <div className={`audio-round-waves ${audioRoundPlaying ? 'playing' : ''}`}>
                <span className="bar" /><span className="bar" /><span className="bar" /><span className="bar" /><span className="bar" />
              </div>
              <div
                role="button"
                tabIndex={0}
                onClick={(e) => { e.stopPropagation(); if (audioRoundDidDragRef.current) return; const a = audioRoundAudioRef.current; if (!a) return; if (a.paused) a.play(); else a.pause(); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); const a = audioRoundAudioRef.current; if (a) { if (a.paused) a.play(); else a.pause(); } } }}
                onMouseEnter={() => setAudioRoundOverlayHovered(true)}
                onMouseLeave={() => setAudioRoundOverlayHovered(false)}
                style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', background: !audioRoundPlaying ? 'rgba(0,0,0,0.3)' : (audioRoundOverlayHovered ? 'rgba(0,0,0,0.2)' : 'transparent') }}
              >
                {!audioRoundPlaying && <svg width="56" height="56" viewBox="0 0 24 24" fill="rgba(255,255,255,0.95)" style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}><path d="M8 5v14l11-7z" /></svg>}
                {audioRoundPlaying && audioRoundOverlayHovered && <svg width="40" height="40" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" /></svg>}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button type="button" onClick={async () => {
              if (!audioRoundBlob || !audioRoundContainerKey) return;
              setCommentUploading(true);
              try {
                const { data: { user } } = await supabase.auth.getUser();
                const userId = user?.id || 'anonymous';
                const path = `users/${userId}/lessons/${lessonId || 'draft'}/comments/${audioRoundContainerKey}/${Date.now()}-audio.webm`;
                const file = new File([audioRoundBlob], 'audio.webm', { type: audioRoundBlob.type });
                const url = await uploadFile(file, path);
                setContainerComments(prev => ({ ...prev, [audioRoundContainerKey]: [...(prev[audioRoundContainerKey] || []), { type: 'audio', body: url, createdAt: new Date().toISOString() }] }));
                setExpandedCommentKey(null);
                // Stable position: stack vertically per container in a
                // dedicated audio "lane" instead of inheriting the
                // floating preview's viewport coords.
                setInsertedRoundAudios(prev => {
                  const existing = prev.filter(a => a.containerKey === audioRoundContainerKey).length;
                  const pos = { x: 24, y: 200 + existing * 150 };
                  return [...prev, { id: `ra-${Date.now()}-${Math.random().toString(36).slice(2)}`, containerKey: audioRoundContainerKey, audioUrl: url, position: pos, currentTime: 0, duration: 1, playing: false, overlayHovered: false }];
                });
              } catch (err) { console.error(err); }
              finally { setCommentUploading(false); }
              if (audioRoundUrl) URL.revokeObjectURL(audioRoundUrl);
              setAudioRoundState(null); setAudioRoundContainerKey(null); setAudioRoundBlob(null); setAudioRoundUrl(null);
            }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.filter = 'brightness(1.06)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.filter = ''; }}
              style={{
                padding: '8px 20px',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: '#fff', border: 'none', borderRadius: 999,
                cursor: 'pointer', fontSize: 13, fontWeight: 600,
                boxShadow: '0 4px 12px rgba(99, 102, 241, 0.32)',
                transition: 'transform 140ms ease, filter 140ms ease',
              }}>Insert</button>
            <button
              type="button"
              onClick={() => { if (audioRoundUrl) URL.revokeObjectURL(audioRoundUrl); setAudioRoundState(null); setAudioRoundContainerKey(null); setAudioRoundBlob(null); setAudioRoundUrl(null); }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.18)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)'}
              style={{
                padding: '8px 18px',
                background: 'rgba(255, 255, 255, 0.08)',
                color: '#e2e8f0', border: '1px solid rgba(255, 255, 255, 0.18)',
                borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 500,
                transition: 'background 140ms ease',
              }}>Cancel</button>
          </div>
        </div>
      )}

      {/* Текстовый комментарий: превью — перетаскиваемый пузырь, Insert/Cancel */}
      {textRoundState === 'preview' && textRoundDraft && textRoundContainerKey && (
        <div style={{ position: 'fixed', left: textRoundPosition.x, top: textRoundPosition.y, zIndex: 10001, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div
            style={{ maxWidth: 280, padding: '12px 14px', background: '#fff', border: '1px solid #e0e0e0', borderRadius: 12, boxShadow: '0 6px 20px rgba(0,0,0,0.15)', cursor: 'grab', borderLeft: '4px solid #5c6bc0' }}
            onMouseDown={(e) => { if (e.target.closest('button')) return; e.preventDefault(); textRoundDragRef.current = { isDragging: true, startX: e.clientX, startY: e.clientY, startLeft: textRoundPosition.x, startTop: textRoundPosition.y }; }}
            onTouchStart={(e) => { if (e.target.closest('button')) return; const t = e.touches[0]; textRoundDragRef.current = { isDragging: true, startX: t.clientX, startY: t.clientY, startLeft: textRoundPosition.x, startTop: textRoundPosition.y }; }}
          >
            <p style={{ margin: 0, fontSize: 14, whiteSpace: 'pre-wrap', lineHeight: 1.4, color: '#333' }}>{textRoundDraft}</p>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button type="button" onClick={() => {
              if (!textRoundDraft || !textRoundContainerKey) return;
              setContainerComments(prev => ({ ...prev, [textRoundContainerKey]: [...(prev[textRoundContainerKey] || []), { type: 'text', body: textRoundDraft, createdAt: new Date().toISOString() }] }));
              setExpandedCommentKey(null);
              const pos = homeworkContentRef.current ? (() => { const r = homeworkContentRef.current.getBoundingClientRect(); return { x: textRoundPosition.x - r.left, y: textRoundPosition.y - r.top }; })() : { x: textRoundPosition.x, y: textRoundPosition.y };
              setInsertedRoundTexts(prev => [...prev, { id: `rt-${Date.now()}-${Math.random().toString(36).slice(2)}`, containerKey: textRoundContainerKey, body: textRoundDraft, position: pos }]);
              setTextRoundState(null); setTextRoundContainerKey(null); setTextRoundDraft('');
            }} style={{ padding: '8px 16px', background: '#5c6bc0', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Insert</button>
            <button type="button" onClick={() => { setTextRoundState(null); setTextRoundContainerKey(null); setTextRoundDraft(''); }} style={{ padding: '8px 16px', background: '#555', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Cancel</button>
          </div>
        </div>
      )}
    </>
  );
}
